import { render, staticRenderFns } from "./DelegationOrderView.vue?vue&type=template&id=1d210ac2&scoped=true&"
import script from "./DelegationOrderView.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d210ac2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d210ac2')) {
      api.createRecord('1d210ac2', component.options)
    } else {
      api.reload('1d210ac2', component.options)
    }
    module.hot.accept("./DelegationOrderView.vue?vue&type=template&id=1d210ac2&scoped=true&", function () {
      api.rerender('1d210ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-order/DelegationOrderView.vue"
export default component.exports